/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function TimePointRepresentationFromJSON(json) {
    return TimePointRepresentationFromJSONTyped(json, false);
}
export function TimePointRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        month: json['month'],
        year: json['year'],
        quarter: json['quarter'],
        active: json['active'],
    };
}
export function TimePointRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        month: value.month,
        year: value.year,
        quarter: value.quarter,
        active: value.active,
    };
}
